import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { InlineSVGModule } from "ng-inline-svg-2";
import { SharedModule } from "../../../../../shared/shared.module";
import { LangSwitcherComponent } from "./lang-switcher.component";

@NgModule({
  declarations: [LangSwitcherComponent],
  imports: [CommonModule, InlineSVGModule, SharedModule],
  exports: [LangSwitcherComponent],
})
export class LangSwitcherModule {}
